@for (card of cards(); track card.value) {
  <div
    class="py-x-sm flex items-center justify-between border-b border-neutral-200"
    [class.cursor-pointer]="!card.isSelected || section() === 'select'"
    [class.cursor-not-allowed]="card.isSelected && section() !== 'select'"
    [class.half-opacity]="card.isSelected && section() !== 'select'"
    (click)="onSelectCard(card)">
    <div class="flex items-center gap-md">
      @if (!card.image) {
        <div
          class="avatar flex items-center justify-center rounded-full py-md bg-primary-50">
          <span class="text-xs text-primary-500">
            {{ card.label | avatar }}
          </span>
        </div>
      } @else {
        <img
          class="avatar rounded-full"
          [src]="card.image.url"
          [alt]="card.label" />
      }

      <div>
        <div class="text-neutral-900 text-xs font-semibold">
          {{ card.label }}
        </div>

        <div class="text-neutral-500 text-xs">
          {{
            itemType() === 'Group'
              ? ('assign_items_modal_group_label' | transloco)
              : card.job_title
                ? card.job_title
                : ('assign_items_modal_user_label' | transloco)
          }}
        </div>
      </div>
    </div>

    <div>
      @if (section() === 'results') {
        <span
          class="checkmark rounded-sm bg-white flex items-center justify-center"
          [class.border-neutral-300]="
            !card.isSelected || section() === 'select'
          "
          [class.border-primary-500]="card.isSelected"
          [class.checked]="card.isSelected">
          @if (card.isSelected) {
            <svg
              width="16"
              height="12"
              class="w-4 h-3 text-white"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.3801 1.08532C14.6091 1.29524 14.6246 1.65106 14.4146 1.88007L6.16465 10.8801C6.06098 10.9932 5.91561 11.059 5.76222 11.0623C5.60883 11.0657 5.46074 11.0062 5.35225 10.8977L1.60225 7.14772C1.38258 6.92805 1.38258 6.5719 1.60225 6.35223C1.82192 6.13256 2.17808 6.13256 2.39775 6.35223L5.73233 9.68681L13.5854 1.11988C13.7953 0.890873 14.1511 0.875403 14.3801 1.08532Z"
                fill="currentColor"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          }
        </span>
      } @else {
        <lib-remove-item-icon [iconClass]="'size-6 text-destructive-500'" />
      }
    </div>
  </div>
} @empty {
  <div class="flex flex-col justify-center items-center mt-2xl">
    <lib-no-user-data-icon [iconClass]="'size-25'" />

    <h6 class="text-xl font-semibold text-neutral-900 mt-lg">
      {{ 'no_data_available_label' | transloco }}
    </h6>

    <p class="text-neutral-500 text-sm font-medium mt-sm">
      {{ 'section_no_data_description' | transloco }}
    </p>
  </div>
}
